import ActionTypes from '../actions/types';
import { setState, setObjectToState, appendItemToStateArray, deleteItemToStateArray } from './helper';
import { defaultState } from './defaultState';
/*eslint no-case-declarations: 0 */

/**
  This is session reducers.
  we are not saving this reducers data to localStorage.
  On each Refresh this reducer state will be flushed
**/

const initialState = defaultState.session;

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_TOASTER_MESSAGE:
      return appendItemToStateArray(state, {newItem: action.toaster}, 'toasters');

    case ActionTypes.DELETE_TOASTER_MESSAGE_BY_ID:
      const findFunction = item => item.id === action.id;
      return deleteItemToStateArray(state, {findFunction}, 'toasters');

    case ActionTypes.UPDATE_BLOCKED_SPOTS_LIST:
      return setState(state, action, 'blockedSpotsList');

    case ActionTypes.SET_PARKING_SPOT_FEATURES_LIST:
      return setState(state, action, 'parkingSpotFeaturesList');

    case ActionTypes.SET_AREA_SPOTS_MAPPING_LIST:
      return setState(state, action, 'areaSpotsMapList');

    case ActionTypes.UPDATE_PREBOOKED_SPOTS_LIST:
      return setState(state, action, 'preBookedSpotsList');

    case ActionTypes.UPDATE_BOOKING_OPEN_INFO:
      const { isBookingOpen, eventType, openTime, closeTime } = action;
      return setObjectToState(state, {
        isBookingOpen,
        eventType,
        openTime,
        closeTime
      });

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/sessionReducer.js